export enum RequestHeader {
  SkipInterceptor = 'Skip-Interceptor',
  UseInterceptor = 'Use-Interceptor',
  Authorization = 'Authorization',
  IntrackHubId = 'IntrackHubId',
}

export enum ResponseHeader {
  RefreshToken = 'refresh-token-header',
}
